import { AfterViewInit,Component, ViewChild } from '@angular/core';
import { NavController, Nav, NavParams, AlertController, ToastController, LoadingController, MenuController, ModalController, Events, Select } from 'ionic-angular';
import { UserMyRadiant as User,LoginMyRadiant ,RepositoryMyRadiant, NotificationProvider, HelperMyRadiant, FaskerProvider, NotesMyTeamProvider } from '@providers/index';
import { ForbidenloginComponent } from "../../../components/forbidenlogin/forbidenlogin";
import { LoginPage,TabsPage,HomePage, NotifikasiPage } from "../";

import { IonicImageLoader } from 'ionic-image-loader';
import { EditPegawai } from './edit_profil/page';
import { cmpFilterKaryawan } from "../../../components/presensi";
import { DetailPresensi } from './detail_presensi/page';
import { cmpMyOrganization } from '../../../components/myOrganization/cmp';
import { DailyActivity, DetailNotesMyTeam } from '@src/components/Content';
// import { SuperTabs  } from '@ionic-super-tabs/angular';



@Component({
  selector: 'page-profil',
  templateUrl: 'page.html'
})
export class ProfilPage implements AfterViewInit {
  ngAfterViewInit(): void {
    // console.log('Super tabs is ', this.superTabs);
    // this.superTabs.selectTab(1);
  }

  // @ViewChild(SuperTabs) superTabs: SuperTabs;
  
  emp    : any;
  loading: any;
  selectedTabIndex = 0;
  homePage          : HomePage;
  btnTabProfilActive: string = "Identity";
  segmentActive     : string = "general";
  stateRequest      : any;
  // maxStateRequest = 12;

  parameter = {
    id       : this.userApi.data.Employee_ID,
    user_code: this.userApi.data.NIK,
    nik      : this.userApi.data.NIK,
    token    : 1,
    user_nik : "",
    flag     : "team",
  }

  data:any = {
    jml_notifikasi:this.notifikasiProvider.jmlNotifikasi,
    employee : 'Me',
    department_selected:{
      fasker:"",
      advance:""
    },
    expired:{
      mcu:'',
      insurance:'',
    },
    state_expired:{
      mcu:'',
      insurance:'',
    },
    presensi:{
      current:[],
      history: [],
    },
    pegawai: {
      name: "-",
      idnumber: "-",
      division:"",
      company:"PT Radiant Utama Interisco",
      ttl:"-",
      religion:"-",
      grade:"-",
      pangkat:"-",
      jabatan:"-",
      startDate:"-",
      education:"-",
      leaveAmount:"-",
      leaveUsed:'-',
      leaveBalance:'-',
      address:'-'
    },    
    general:{

    },
    family:[],
    medical:[{}],
    insurance:[{}],
    certificate:[{}],
    asset:[{}],
    advance:{
      total:0,
      list:[{}]
    },
    project:{
      active:[],
      last:[]
    },
    total:{
      active_project:0,
      active_ticket:0,
      active_fi:0,
      active_hotel:0,
    },
    ticket:{
      active:[],
      last:[],
    },
    hotel:{
      active:[],
      last:[],
    },
    instruction:{
      active:[],
      last:[],
    }
  };

  @ViewChild('filterKaryawan') selectRef: Select;
  constructor(
    public navCtrl              : NavController,
    public navParams            : NavParams,
    private toastCtrl           : ToastController,
    public loadingCtrl          : LoadingController,
    public userApi              : User,
    public nav                  : Nav,
    public loginProvider        : LoginMyRadiant,
    private menuCtrl            : MenuController,
    public modalCtrl            : ModalController,  
    public repositoryMyRadiant  : RepositoryMyRadiant,
    public notifikasiProvider   : NotificationProvider,
    public events               : Events,
    public helper               : HelperMyRadiant,
    public faskerProvider       : FaskerProvider,
    public notesProvider        : NotesMyTeamProvider,
    // public imgLoader     : IonicImageLoader,
  ) {
    this.emp = this.userApi.data;
    console.log("user data => ", this.emp);

    this.validasiLogin(this.loginProvider.checkIsLogin());
    localStorage.setItem('presensi_karyawan_attendance','me');
    this.notifikasiProvider.refreshNotification();
    this.events.subscribe('notification:update',(notif) => {
      this.data.jml_notifikasi = notif.jml_notifikasi;
    });
    this.events.subscribe('presensi:reload',()=>{
      this.getPresensi();
    })

    this.events.subscribe('notes:inactive', () => {
      this.stateRequest = 1;
      this.loading = this.helper.showLoading("Loading...");
      this.getNotes();
    });

    this.events.subscribe('notes:edit', () => {
      this.stateRequest = 1;
      this.loading = this.helper.showLoading("Loading...");
      this.getNotes();
    });

  }

  filterKaryawan(){
    let me = this;
    this.showLoading();
    let params = {
      id:this.userApi.data.Employee_ID,
      active_tab:this.btnTabProfilActive,
    };
    this.repositoryMyRadiant.checkBeforeGetBawahan(params).subscribe((resp:any) => {
        try {
          this.loading.dismiss();
        } catch (error) {
          
        }
      if(resp.success){
        let karyawanModal = this.modalCtrl.create(cmpFilterKaryawan, {
          active_tab    : params.active_tab,
          karyawan      : resp.data.list,
          isAddHoc      : resp.data.isAddHoc,
          fiturSearching: true,
          title         : "My Team Profile",
          level         : resp.data.level},
          {cssClass: 'select-modal',
          enableBackdropDismiss:false });
        karyawanModal.onDidDismiss(karyawan => {
          if(karyawan){
            if (karyawan=='me') {
              me.data.employee                    = "Me";
              me.parameter.nik                    = this.userApi.data.NIK;
              me.parameter.user_code              = this.userApi.data.NIK;
              me.parameter.id                     = this.userApi.data.Employee_ID;
              me.data.department_selected.fasker  = "";
              me.data.department_selected.advance = "";
              me.parameter.flag                   = "team";
            }else{
              me.data.employee                    = karyawan.name;
              me.parameter.nik                    = karyawan.nik;
              me.parameter.user_code              = karyawan.nik;
              me.parameter.id                     = karyawan.id;
              me.data.department_selected.fasker  = "";
              me.data.department_selected.advance = "";
              me.parameter.flag                   = "team";
            }
            // this.showLoading();
            me.validasiLogin(1);
          }
        });
        karyawanModal.present();
      }
    },(err) => {
      this.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    });    
  }

  validasiLogin(isLogin){
    if (isLogin == 1 || isLogin == 2) {
      this.showLoading();
      this.stateRequest = 13;
      this.getGeneral();
      this.getAssets();
      this.getAdvance();
      this.getProject();
      this.getFamily();
      this.getMedical();
      this.getInsurance();
      this.getCeritificate();
      this.getTicket();
      this.getInstruction();
      this.getHotel();
      this.getPresensi();
      this.getNotes();
    }else if(isLogin == 0){
      let forbidenModal = this.modalCtrl.create(ForbidenloginComponent);
      forbidenModal.onDidDismiss(menu => {
        if (menu=="home") {
          this.nav.setRoot(TabsPage,{tabIndex:0});          
        } else {
          this.nav.setRoot(LoginPage);
        }
      });
      forbidenModal.present();
      // let myItem = localStorage.getItem('stateLoadBerita');
      localStorage.clear();
      // localStorage.setItem('stateLoadBerita',myItem);
      this.menuCtrl.enable(false, 'MainMenu');
    }
    // if(loading){
      // try {
      //   this.loading.dismiss();
      // } catch (error) {}
    // }
  }

  onTabSelect(ev: any) {
    this.selectedTabIndex = ev.index;
  }

  showLoading(){
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }
    
  changeTabProfil(evt,tab){
    this.btnTabProfilActive = tab;
    localStorage.setItem('tabActiveProfile',tab);
  }

  expandSegment(evt,segment): void {
    this.segmentActive = segment;
  }
  collapseSegment(evt,segment){
    this.segmentActive = 'none';
  }

  getGeneral(){
    let me = this;
    this.repositoryMyRadiant.getProfilGeneral(this.parameter).subscribe((resp:any) => {
    this.stateRequest = this.stateRequest - 1;
    if (this.stateRequest == 0) {
      try {
        this.loading.dismiss();
      } catch (error) {
      }
    }
      if(resp.success){
        me.data.pegawai.name      = resp.data.name;
        me.data.pegawai.idnumber  = resp.data.code;
        me.data.pegawai.jabatan   = resp.data.position_name;
        me.data.pegawai.division  = resp.data.division_name;
        me.data.pegawai.img       = resp.data.img;  

        me.data.general = resp.data;
      }
    },(err) => {
      this.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }

  getAssets(){
    let me = this;
    this.repositoryMyRadiant.getProfilAssets(this.parameter).subscribe((resp:any) => {
      this.stateRequest = this.stateRequest - 1;
      if(this.stateRequest == 0){
        try {
          this.loading.dismiss();
        } catch (error) {
          
        }
      }
      if(resp.success){
        me.data.asset = resp.data;
      }
    },(err) => {
      this.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }

  getAdvance(){
    let me = this;
    this.parameter.user_nik = this.parameter.nik;
    this.repositoryMyRadiant.getProfilAdvance(this.parameter).subscribe((resp:any) => {
      this.stateRequest = this.stateRequest - 1;
      if(this.stateRequest == 0){
        try {
          this.loading.dismiss();
        } catch (error) {
          
        }
      }
      if(resp.success){
        // me.data.advance.total = resp.total_amount != null ? resp.total_amount.total_amount : 0;
        me.data.advance.total = resp.totalAmount;
        me.data.advance.list = resp.data;
      }
    },(err) => {
      this.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }

  getProject(){
    let me = this;
    this.repositoryMyRadiant.getProfilProject(this.parameter).subscribe((resp:any) => {
      this.stateRequest = this.stateRequest - 1;
      if(this.stateRequest == 0){
        try {
          this.loading.dismiss();
        } catch (error) {
          
        }
      }
      if(resp.active.success){
        me.data.total.active_project = resp.active.data.length;
        me.data.project.active = resp.active.data;
      }
      if(resp.last.success){
        me.data.project.last = resp.last.data;
      }
    },(err) => {
      this.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }

  getFamily(){
    let me = this;
    this.repositoryMyRadiant.getProfilFamily(this.parameter).subscribe((resp:any) => {
      this.stateRequest = this.stateRequest - 1;
      if(this.stateRequest == 0){
        try {
          this.loading.dismiss();
        } catch (error) {
          
        }
      }
      if(resp.success){
        me.data.family = resp.data;
      }
    },(err) => {
      this.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }

  getMedical(){
    let me = this;
    this.repositoryMyRadiant.getProfilMedical(this.parameter).subscribe((resp:any) => {
      this.stateRequest = this.stateRequest - 1;
      if(this.stateRequest == 0){
        try {
          this.loading.dismiss();
        } catch (error) {
          
        }
      }
      if(resp.success){
        me.data.medical = resp.data;
        me.data.expired.mcu = resp.expired_date;
        me.data.state_expired.mcu = resp.state_expired;
      }
    },(err) => {
      this.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }

  getInsurance(){
    let me = this;
    this.repositoryMyRadiant.getProfilInsurance(this.parameter).subscribe((resp:any) => {
      this.stateRequest = this.stateRequest - 1;
      if(this.stateRequest == 0){
        try {
          this.loading.dismiss();
        } catch (error) {
          
        }
      }
      if(resp.success){
        me.data.insurance = resp.data;
        me.data.expired.insurance = resp.expired_date;
      }
    },(err) => {
      this.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }

  getCeritificate(){
    let me = this;
    this.repositoryMyRadiant.getProfilCeritificate(this.parameter).subscribe((resp:any) => {
      this.stateRequest = this.stateRequest - 1;
      if(this.stateRequest == 0){
        try {
          this.loading.dismiss();
        } catch (error) {
          
        }
      }
      if(resp.success){
        me.data.certificate = resp.data;
      }
    },(err) => {
      this.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }

  getNotes(){
    let me = this;
    let params = this.parameter;
    params['session_employee_id'] = this.userApi.data.Employee_ID;
    this.repositoryMyRadiant.getProfilNotes(params).subscribe((resp:any) => {
      this.stateRequest = this.stateRequest - 1;
      if(this.stateRequest == 0){
        try {
          this.loading.dismiss();
        } catch (error) {
          
        }
      }
      if(resp.success){
        me.data.notes = resp.data;
      }
    },(err) => {
      this.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }

  getTicket(){
    let me = this;
    this.repositoryMyRadiant.getProfilTicket(this.parameter).subscribe((resp:any) => {
      this.stateRequest = this.stateRequest - 1;
      if(this.stateRequest == 0){
        try {
          this.loading.dismiss();
        } catch (error) {
          
        }
      }
      if(resp.success){
        me.data.total.active_ticket = 0;
        me.data.ticket.active = [];
        me.data.ticket.last   = [];
        resp.data.forEach(row => {
          if(row.flag=='current'){
            me.data.total.active_ticket = me.data.total.active_ticket + 1;
            me.data.ticket.active.push(row);
          }
          if(row.flag=='last'){
            me.data.ticket.last.push(row);
          }
        });
      }
    },(err) => {
      this.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }

  getPresensi(){
    let me = this;
    this.repositoryMyRadiant.getProfilPresensi(this.parameter).subscribe((resp:any) => {
      this.stateRequest = this.stateRequest - 1;
      if(this.stateRequest == 0){
        try {
          this.loading.dismiss();
        } catch (error) {
          
        }
      }
      if(resp.success){
        me.data.presensi.current   = [];
        me.data.presensi.history   = [];
        resp.data.records.forEach(row => {
          if (row.flag_data=='current') {
            if (row.state_font == 'black') {
              row.state_font = 'green';
            }
            me.data.presensi.current.push(row);
          }else{
            me.data.presensi.history.push(row);
          }
        });
      }
    },(err) => {
      this.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }

  getHotel(){
    let me = this;
    this.repositoryMyRadiant.getProfilHotel(this.parameter).subscribe((resp:any) => {
      this.stateRequest = this.stateRequest - 1;
      if(this.stateRequest == 0){
        try {
          this.loading.dismiss();
        } catch (error) {
          
        }
      }
      if(resp.success){
        me.data.total.active_hotel = 0;
        me.data.hotel.active = [];
        me.data.hotel.last   = [];
        resp.data.forEach(row => {
          if(row.flag=='current'){
            me.data.total.active_hotel = me.data.total.active_hotel + 1;
            me.data.hotel.active.push(row);
          }
          if(row.flag=='last'){
            me.data.hotel.last.push(row);
          }
        });
      }
    },(err) => {
      this.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }

  getInstruction(){
    let me = this;
    this.repositoryMyRadiant.getProfilFI(this.parameter).subscribe((resp:any) => {
      this.stateRequest = this.stateRequest - 1;
      if(this.stateRequest == 0){
        try {
          this.loading.dismiss();
        } catch (error) {
          
        }
      }
      if(resp.success){
        me.data.total.active_fi = 0;
        me.data.instruction.active = [];
        me.data.instruction.last   = [];
        resp.data.forEach(row => {
          if(row.flag=='current'){
            me.data.total.active_fi = me.data.total.active_fi + 1;
            me.data.instruction.active.push(row);
          }
          if(row.flag=='last'){
            me.data.instruction.last.push(row);
          }
        });
      }
    },(err) => {
      this.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }

  togleSegment(content,active){
    if(content == active){
      this.collapseSegment(null,content);
    }else{
      this.expandSegment(null,content);
    }
  }

  showEditPgw(){
    this.nav.push(EditPegawai,{general:this.data.general,family:this.data.family});
  }

  detailPresensi(item){
    this.nav.push(DetailPresensi,{Employee:this.parameter.id,month:item.Bulan,year:item.Tahun,date:item.Date});
  }

  myDept(evt){
    let me = this;
    this.showLoading();
    let params = {
      id:this.userApi.data.Employee_ID,
      active_tab:this.btnTabProfilActive,
    };
    this.repositoryMyRadiant.getMyOrganization(params).subscribe((resp:any) => {
        try {
          this.loading.dismiss();
        } catch (error) {
          
        }
      if(resp.success){
        let departmentModal = this.modalCtrl.create(cmpMyOrganization, {karyawan:resp.data.list,isAddHoc:resp.data.isAddHoc,fiturSearching:true,title:"My Dept",level:resp.data.level}, {cssClass: 'select-modal',enableBackdropDismiss:false });
        departmentModal.onDidDismiss(department => {
          if(department){
            if (department=='me') {
              me.data.employee = "Me";
              me.parameter.nik = this.userApi.data.NIK;
              me.parameter.user_code = this.userApi.data.NIK;
              me.parameter.id = this.userApi.data.Employee_ID;
              me.parameter.flag = "team";
              if (me.btnTabProfilActive == 'Asset') {
                me.data.department_selected.fasker = "";
              }else if(me.btnTabProfilActive == "Advance"){
                me.data.department_selected.advance = "";
              }
            }else{
              me.data.employee = department.TEXT;
              me.parameter.nik = department.department_id;
              me.parameter.user_code = department.department_id;
              // me.parameter.id = department.id;
              me.parameter.flag = "dept";
              if (me.btnTabProfilActive == 'Asset') {
                me.data.department_selected.fasker = department.TEXT;
              }else if(me.btnTabProfilActive == "Advance"){
                me.data.department_selected.advance = department.TEXT;
              }
            }
            // this.showLoading();
            console.log(me.btnTabProfilActive);
            switch (me.btnTabProfilActive) {
              case 'Asset':
                me.getAssets();
                break;
              case 'Advance':
                me.getAdvance();
                break;
              default:
                break;
            }
          }
        });
        departmentModal.present();
      }
    },(err) => {
      this.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    });
  }
  
  showNotification(){
    this.nav.push(NotifikasiPage);
  }

  reportFasker(data){
    let me = this;
    console.log(data);
    let element_content = `
      <div style="width:100%;padding: 1px 10px;" >
        <h5 class="text-biru" text-left style="font-size:15px;">
          `+data.asset_name+`
        </h5>
        <p class="text-abu" style="margin-top:0px;font-size:14px;" text-left>`+data.asset_new_code+`</p>
      </div> 
      <div style="padding:10px">
        <textarea class="swal-content__textarea" rows="7" id="notes-report-fasker" placeholder="Enter Notes Here..">`+this.helper.ifvalnull(data.report_message,'')+`</textarea>
      </div> 
    `;
    let options = {
      title : "Report",
      content : element_content
    };
    let params = {
      report       : '',
      asset_id     : data.id,
      asset_name   : data.asset_name,
      employee_name: me.userApi.data.Nama_Karyawan,
      code_rui     : data.asset_new_code,
      location_id  : data.asset_location_id,
      employee_id  : me.userApi.data.employee_id,
      updated_at   : data.updated_at
    };
    this.helper.presentSwalCustomContent(options,() => {
      params.report = document.getElementById('notes-report-fasker')['value'];
      me.faskerProvider.addReport(params).subscribe((resp:any) => {
        if (resp.success) {
          me.stateRequest = 1;
          me.loading = me.helper.showLoading("Loading data...");
          me.getAssets();
        }
      });
    })
  }

  detailNotes(data){
    let me = this;
    let activityPopup = this.modalCtrl.create(DetailNotesMyTeam, {data : data }, {cssClass: 'select-modal',enableBackdropDismiss:false });
    activityPopup.present();
    
  }

  addNotes(){
    let me = this;
    let element_content = `
      <div style="width:100%;padding: 1px 10px;" >
        <div style="padding:10px">
        <textarea class="swal-content__textarea" rows="7" id="notes-employee-myteam" placeholder="Enter Notes Here.."></textarea>
      </div> 
    `;
    let options = {
      title : "Notes",
      content : element_content
    };
    let params = {
      active_sts    : 1,
      employee_id   : me.parameter.id,
      created_by    : me.userApi.data.employee_id,
      notes         : '',
    };
    this.helper.presentSwalCustomContent(options,() => {
      params.notes = document.getElementById('notes-employee-myteam')['value'];
      me.stateRequest = 1;
      me.loading = me.helper.showLoading("Loading...");
      me.notesProvider.addNotes(params).subscribe((resp:any) => {
        if (resp.success) {
          me.getNotes();
        }
      });
    })
  }
}




// WEBPACK FOOTER //
// ./src/pages/dashboard/profil/page.ts